import {
  ChangeDetectionStrategy,
  Component,
  computed,
  EventEmitter,
  input,
  model,
  Output,
  Signal,
} from '@angular/core';
import { LabelDirective } from '@shared/ui-forms';
import { isResidentialServiceCode, PersonalDetails, ResidentialAddress } from '@shared/ui-service';
import { PhonePipe } from '@shared/ui-shared';

const CSL_IMPORTS = [PhonePipe, LabelDirective];

@Component({
  selector: 'csl-summary-wrapper',
  standalone: true,
  imports: [...CSL_IMPORTS],
  templateUrl: './summary-wrapper.component.html',
  styleUrl: './summary-wrapper.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SummaryWrapperComponent {
  serviceCode$$ = input.required<string>();
  serviceType$$ = input.required<string>();
  address$$ = input.required<ResidentialAddress>();
  companyName$$ = input<string | undefined>();
  personalAddress$$ = input.required<ResidentialAddress>();
  personalDetails$$ = input.required<PersonalDetails>();

  @Output() confirmOrder = new EventEmitter<boolean>();
  @Output() confirmPromo = new EventEmitter<boolean>();

  confirmOrder$$ = model(false);
  confirmPromo$$ = model(false);

  name$$: Signal<string> = computed(() => {
    const { firstName, lastName } = this.personalDetails$$();

    return `${firstName} ${lastName}`;
  });

  toggleConfirmOrder(isConfirmed: boolean): void {
    this.confirmOrder$$.set(isConfirmed);
    this.confirmOrder.emit(isConfirmed);
  }

  toggleConfirmPromo(isConfirmed: boolean): void {
    this.confirmPromo$$.set(isConfirmed);
    this.confirmPromo.emit(isConfirmed);
  }

  isResidentialService(): boolean {
    return isResidentialServiceCode(this.serviceCode$$());
  }
}
